import axiosClient from "@/libs/axiosClient";

export const _channelTest = data => {
    return axiosClient.post(`/validate/channeltest`, data);
};



// WEBPACK FOOTER //
// ./src/api/notificationChannels.js